export default "__VITE_ASSET__BtmD5fit__"